export const SAPURI_EMAIL_REGEXP =
  /^[!-?A-~]{1,80}@[a-zA-Z\d][!-+--?A-~]{0,79}$/;
export const HANKAKU_REGEXP = /^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/;
